import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { faqs } from "./components/FAQ";
import Navbar from "@/components/feature/Navbar";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "@/components/feature/Footer";
import FloatingButton from "@/components/feature/FloatingButton";
import Hero from "./components/Hero";
import CartesTarifs from "./components/CartesTarifs";
import Formulaire from "./components/Formulaire";
import FAQ from "./components/FAQ";
import Maillage from "./components/Maillage";

export default function TarifsPage() {
  return (
    <main>
      <SEOHead
        title="Tarifs Volet Roulant Strasbourg | Réparation & Motorisation"
        description="Tarifs réparation, motorisation et dépannage de volet roulant à Strasbourg et dans le Bas-Rhin. Diagnostic gratuit, devis transparent. 03 74 47 32 40."
        path="/tarifs"
        type="service"
        serviceType="Tarifs réparation volet roulant"
        faqs={faqs}
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Tarifs" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Tarifs" }]} />
      <Hero />
      <CartesTarifs />
      <Formulaire />
      <FAQ />
      <Maillage />
      <Footer />
      <FloatingButton />
    </main>
  );
}